import {Grid2, Tab, Tabs, Typography} from '@mui/material'
import {useMemo} from 'react'
import {useTranslate} from 'react-admin'
import {useLocation} from 'react-router-dom'
import {makeStyles} from 'tss-react/mui'

import TabPanel from '../../components/TabPanel'
import {MerchantUserList} from '../../resources/merchantUsersResource'
import {TagsList} from '../../resources/tagsResource'
import AddNumbersAndMerchantUsers from './AddNumbersAndMerchantUsers'
import ChannelsAndMerchantUsersManagementShow
  from './ChannelsAndMerchantUsersManagementShow'

const CompanySettingsPage = () => {
  const {classes: styles} = useStyles({})
  const translate = useTranslate()
  const hashValue = useLocation().hash.replace('#', '')
  const tab =
    COMPANY_SETTINGS_TABS.find(f => f === hashValue) ?? COMPANY_SETTINGS_TABS[0]
  const tabPanelLabelAndComponents = useTabPanelLabelAndComponents()
  return (
    <Grid2 className={styles.root}>
      <Typography className={styles.title} variant="h2">
        {translate('pages.companySettings.title')}
      </Typography>
      <Tabs
        className={styles.tabs}
        TabIndicatorProps={{children: <span/>}}
        indicatorColor="primary"
        textColor="primary"
        value={tab}
        variant="fullWidth"
      >
        {tabPanelLabelAndComponents.map(([label,, {key: tabFilter}]) => (
          <Tab key={tabFilter} label={label} value={tabFilter} href={`#${tabFilter}`} />
        ))}
      </Tabs>
      {tabPanelLabelAndComponents.map(([, TabPanelComponent, {key: tabFilter}]) => (
        <TabPanel
          key={tabFilter}
          value={tabFilter as string}
          isSelected={tab === tabFilter}>
          {(tab === tabFilter) && <TabPanelComponent />}
        </TabPanel>
      ))}
    </Grid2>
  )
}

const useTabPanelLabelAndComponents = (): ComponentLabelAndComponent<
  any, CompanySettingsTab
> => {
  const translate = useTranslate()
  return useMemo(
    () => [
      [
        translate('pages.companySettings.tabs.addNumbersAndMerchantUsers.title'),
        AddNumbersAndMerchantUsers,
        {key: CompanySettingsTab.AddNumbersAndMerchantUsers},
      ],
      [
        translate('pages.companySettings.tabs.channels.title'),
        ChannelsAndMerchantUsersManagementShow,
        {key: CompanySettingsTab.Channels},
      ],
      [
        translate('pages.companySettings.tabs.merchantUsersManagement.title'),
        MerchantUserList,
        {key: CompanySettingsTab.MerchantUsers},
      ],
      [
        translate('pages.companySettings.tabs.tagsManagement.title'),
        TagsList,
        {key: CompanySettingsTab.Tags},
      ],
    ] as ComponentLabelAndComponent<CompanySettingsTab>,
    [translate],
  )
}

enum CompanySettingsTab {
  AddNumbersAndMerchantUsers = 'addNumbersAndMerchantUsers',
  Channels = 'channels',
  MerchantUsers = 'merchantUsers',
  Tags = 'tags'
}

const COMPANY_SETTINGS_TABS: CompanySettingsTab[] = [
  CompanySettingsTab.AddNumbersAndMerchantUsers,
  CompanySettingsTab.Channels,
  CompanySettingsTab.MerchantUsers,
  CompanySettingsTab.Tags,
]

const useStyles = makeStyles<any>()(theme => ({
  root: {
    // Disable the react-admin resource List action toolbar's margin on all tabs.
    '& .RaList-actions': {
      margin: 0,
    },
    padding: theme.remSpacing(5),
  },
  tabs: {
    '& .MuiButtonBase-root': {
      flexGrow: 0,
      margin: 0,
      minWidth: 'max-content',
      paddingLeft: theme.remSpacing(4),
      paddingRight: theme.remSpacing(4),
    },
    flexDirection: 'row !important' as any,
    justifyContent: 'start',
  },
  title: {
    marginBottom: theme.remSpacing(10),
  },
}))

export {CompanySettingsTab}
export default CompanySettingsPage
